
export enum VideoPlayerErrorCode {
  HLS_DOES_NOT_SUPPORT = 'HLS_DOES_NOT_SUPPORT',
}
